import ResizeableElement from "./ResizeableElement";
import { useEffect, useRef, useState } from "react";
import { FormControlLabel } from "@mui/material";
import "./ResizeableElement.css";
import PercentageBar from "./PercentageBar";
const ResizeableElementGroup = ({
  isEditEnabled = false,
  onChange = () => {},
  gameStats,
  savedLayouts = [],
  updateSavedLayouts = () => {},
  settings,
}) => {
  const { game, answerStats, totalRespondents = 0 } = gameStats;
  const handleDetailsChange = (e, callback) => {
    e.stopPropagation();
    callback();
  };
  const HEIGHT = 120;
  const WIDTH = 400;
  const [size, setSize] = useState({
    width: WIDTH,
    height: HEIGHT,
  });

  const [selectedElementIds, setSelectedElementIds] = useState([]);
  const onElementSelect = (id, isSelected) => {
    if (isSelected) {
      setSelectedElementIds((prev) => [...prev, id]);
    } else {
      setSelectedElementIds((prev) => prev.filter((elId) => elId !== id));
    }
  };

  useEffect(() => {
    updateSavedLayouts(size, selectedElementIds);
  }, [size]);

  const renderQuestionAndVoteCount = () => {
    const QueId = "questionText";
    const layout = savedLayouts.find((l) => l.id === QueId);
    const newPosition = layout?.position || { x: 0, y: 0 };
    const newSize = layout?.size || { width: WIDTH, height: HEIGHT };

    const voteCOuntId = "votes";
    const vLayout = savedLayouts.find((l) => l.id === voteCOuntId);
    const vNewPosition = vLayout?.position || { x: 0, y: 0 };
    const vNewSize = vLayout?.size || { width: WIDTH, height: HEIGHT };
    return (
      <>
        <ResizeableElement
          id="questionText"
          key="questionText"
          defaultPosition={newPosition}
          defaultSize={newSize}
          isEditEnabled={isEditEnabled}
          onSelect={(isSelected) => {
            onElementSelect(QueId, isSelected);
          }}
          onChange={(changedElement) => {
            changedElement["id"] = QueId;
            onChange(changedElement);
          }}
        >
          <div
            className="gameScreenQuestionText"
            key="question"
            style={{
              fontSize: `${settings?.headingFontSize || 24}px`,
              color: game?.questionTextColor,
              margin: 0,
            }}
          >
            {game?.questionText}
          </div>
        </ResizeableElement>
        {game.isShowTotalVotes && (
          <ResizeableElement
            id={voteCOuntId}
            key={voteCOuntId}
            defaultPosition={vNewPosition}
            defaultSize={vNewSize}
            isEditEnabled={isEditEnabled}
            onSelect={(isSelected) => {
              onElementSelect(voteCOuntId, isSelected);
            }}
            onChange={(changedElement) => {
              changedElement["id"] = voteCOuntId;
              onChange(changedElement);
            }}
          >
            <h2
              className="gameScreenQuestionText"
              style={{
                color: game?.optionTextColor,
                background: "rgba(0,0,0,0.6)",
                padding: "20px",
                borderRadius: "10px",
                margin: 0,
                height: "calc(100% - 40px)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {totalRespondents} Votes
            </h2>
          </ResizeableElement>
        )}
      </>
    );
  };
  return (
    <>
      {renderQuestionAndVoteCount()}
      {answerStats.map((option, index) => {
        const id = `${option.answer.optionText.replaceAll(" ", "")}${index}`;
        const layout = savedLayouts.find((l) => l.id === id);
        const newPosition = layout?.position || { x: 0, y: 0 };
        const newSize = layout?.size || { width: WIDTH, height: HEIGHT };
        return (
          <ResizeableElement
            id={id}
            key={id}
            defaultPosition={newPosition}
            defaultSize={newSize}
            isEditEnabled={isEditEnabled}
            onSelect={(isSelected) => {
              onElementSelect(id, isSelected);
            }}
            onChange={(changedElement) => {
              changedElement["id"] = id;
              onChange(changedElement);
            }}
          >
            <div
              className="gameScreenOptionContainer"
              style={{
                fontSize: `${settings.optionFontSize || 18}px`,
              }}
            >
              <PercentageBar
                percentage={option.percentage}
                correctAnswer={
                  option.answer.optionText === game.correctAnswerText
                }
                correctAnswerValue={game.correctAnswerText}
                option={option.answer}
                optionTextColor={game.optionTextColor}
                highlightBarColor={game.highlightBarColor}
                gameType={game.gameType}
                isActive={game.isActive}
                index={index}
                settings={settings}
              />
            </div>
          </ResizeableElement>
        );
      })}
      {isEditEnabled && (
        <div className="relm-group-details">
          <FormControlLabel
            labelPlacement="start"
            label="W: "
            control={
              <input
                type="number"
                value={size.width}
                className="relm-details-input"
                onChange={(e) => {
                  handleDetailsChange(e, () => {
                    setSize({
                      ...size,
                      width: Number(e.target.value),
                    });
                  });
                }}
              />
            }
          ></FormControlLabel>
          <FormControlLabel
            labelPlacement="start"
            label="H: "
            control={
              <input
                type="number"
                value={size.height}
                className="relm-details-input"
                onChange={(e) => {
                  handleDetailsChange(e, () => {
                    setSize({
                      ...size,
                      height: Number(e.target.value),
                    });
                  });
                }}
              />
            }
          ></FormControlLabel>
        </div>
      )}
    </>
  );
};
export default ResizeableElementGroup;
